module.exports = __webpack_public_path__ + "img/pw.7945b215.svg";